import { timeSpanGridFactory, TimeSpanGridProps } from "./timeSpanGridFactory";

export type WeekSpanGridProps = TimeSpanGridProps;

export const WeekSpanGrid = timeSpanGridFactory("weeks", 52, (x) => x.isoWeek());
